import React from 'react';
import { useSelector } from 'react-redux';
import VideoPreview from '../../../ui/videoPreview/VideoPreview';
import YouTubeLogo from '../../../ui/youtubeLogo/YouTubeLogo';
import classes from './FinalLiveVideo.module.css';

const FinalLiveVideo = () => {

  const { contentInfoJson } = useSelector((state) => state.contest)
  const { texts } = useSelector((state) => state.translate);

  return (
    <div className={classes.container}>
      <p className={classes.sectionTitle}> {texts.watchLiveBroadcast} </p>
      <div className={classes.content}>
        <div className={classes.info}>
          <div className={classes.youtubeRow}>
            <YouTubeLogo link={contentInfoJson?.final?.linkYouTube}/>
          </div>
          <p className={classes.extraText}>{texts?.finalBroadcastText}</p>
        </div>
        <div className={classes.videoWrap}>
          <VideoPreview url={contentInfoJson?.final?.liveVideo} alt={contentInfoJson?.final?.liveVideo?.alt ?? ''} duration={contentInfoJson?.final?.liveVideo?.duration} />
        </div>
      </div>
    </div>
  );
};

export default FinalLiveVideo;
